import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axiosInstance from "../services/axiosInstance";
import DentalLogo from "../assets/images/dentallabor_schreiber.png";
import ForgetImage from "../assets/images/Forgot pass.png";
import ResetPopup from "../Popup/resetPopup";
import VerifyTokenPopup from "../Popup/verifyTokenPopup";
import { ERROR_MESSAGES_RESET } from "../enums/Constants";

const Reset = () => {
  const [validToken, setValidToken] = useState(false);
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    pin: "",
    cpin: "",
  });
  const [formError, setFormError] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopup2, setOpenPopup2] = useState(false);

  const HandleClosePopup = () => setOpenPopup(false);
  const HandleClosePopup2 = () => setOpenPopup2(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    // Restrict input length and non-numeric values for the password
    if (id === "pin" && (!/^\d*$/.test(value) || value.length > 4)) return;
    if (id === "cpin" && (!/^\d*$/.test(value) || value.length > 4)) return;
    setFormData({ ...formData, [id]: value });

    // Reset error for the field
    setErrors({ ...errors, [id]: "" });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!/^\d{4}$/.test(formData.pin)) {
      isValid = false;
      newErrors.pin = ERROR_MESSAGES_RESET.REQUIRED_PIN;
    }

    if (!/^\d{4}$/.test(formData.cpin)) {
      isValid = false;
      newErrors.cpin = ERROR_MESSAGES_RESET.REQUIRED_CPIN;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      postResetPin();
    }
  };

  const postResetPin = async () => {
    const token = new URLSearchParams(location.search).get("token");
    try {
      const response = await axiosInstance.post("/api/auth/resetPassword", {
        NewPIN: formData.pin,
        ConfirmPIN: formData.cpin,
        Token: token,
      });
      if (response) {
        setFormError("");
        setOpenPopup(true);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
      if (error.response.data.message || error.response.data) {
        const serverErrors = error.response.data?.message
          ? error.response.data.message
          : error.response.data;
        setFormError(serverErrors || ERROR_MESSAGES_RESET.UNEXPECTED);
      } else {
        setFormError(ERROR_MESSAGES_RESET.UNEXPECTED);
      }
    }
  };

  useEffect(() => {
    const validateToken = async () => {
      const token = new URLSearchParams(location.search).get("token");
      if (token) {
        try {
          const response = await axiosInstance.post(
            "/api/auth/validateResetToken",
            {
              Token: token,
            }
          );
          setValidToken(true);
        } catch (error) {
          console.error("Failed to validate token:", error);
          setOpenPopup2(true); // Always open the popup for token validation error
          setValidToken(false); // Mark the token as invalid
        }
      }
    };

    validateToken();
  }, [location]);

  return (
    <>
      {validToken && (
        <div className="flex items-center h-screen">
          {/* component 1 */}
          <div className="lg:w-1/2 w-full lg:block hidden">
            <img
              src={ForgetImage}
              alt="Login"
              className=" w-full object-cover h-screen"
            />
          </div>
          {/* component 2 */}
          <div
            className="relative self-center lg:w-1/2 w-full h-full px-5 flex justify-center items-center 
        before:content-[''] before:bottom-0 before:right-0 before:w-full before:h-full before:bg-auto before:bg-right-bottom before:bg-no-repeat before:absolute before:bg-[url('./assets/images/schreiber-right.svg')] 
        before:lg:bg-transparent before:bg-[#0000004a] after:content-[''] after:bottom-0 after:left-0 after:w-[150px] after:h-[166px] after:bg-auto after:bg-left-bottom after:bg-no-repeat after:absolute after:bg-[url('./assets/images/schreiber-left.svg')] 
        "
          >
            <div className="relative 2xl:w-5/12 xl:w-1/2 lg:w-3/4 w-5/6 bg-white rounded-3xl lg:p-0 p-8">
              <img
                src={DentalLogo}
                alt="Dentallabor Schreiber"
                className="mx-auto"
              />
              <h1 className="pt-7 lg:pt-10 2xl:pt-20 text-center text-5xl font-bold font-roboto text-gray-600 mb-8">
                Setzen Sie Ihre Pin hier zurück!
              </h1>
              {formError && <p className="text-red text-sm">{formError}</p>}
              <form className="login_page">
                <div className="mb-5 font-inter">
                  <label
                    className="block text-gray-600 text-2xl font-medium font-inter mb-2"
                    htmlFor="password"
                  >
                    Neue 4-stellige Pin eingeben
                  </label>
                  <input
                    className={`appearance-none border font-regular font-inter border-gray rounded-lg w-full py-3 px-5 text-gray-600 placeholder:text-gray-400 focus:outline-none focus:shadow-outline ${
                      errors.pin ? "border-red" : ""
                    }`}
                    id="pin"
                    type="password"
                    placeholder="Neue Pin eingeben"
                    value={formData.pin}
                    onChange={handleChange}
                    maxLength={4}
                  />
                  {errors.pin && (
                    <p className="text-red text-sm mt-1">{errors.pin}</p>
                  )}
                </div>
                <div className="mb-5 font-inter">
                  <label
                    className="block text-gray-600 text-2xl font-medium font-inter mb-2"
                    htmlFor="password"
                  >
                    Neue 4-stellige Pin Bestätigen
                  </label>
                  <input
                    className={`appearance-none border font-regular font-inter border-gray rounded-lg w-full py-3 px-5 text-gray-600 placeholder:text-gray-400 focus:outline-none focus:shadow-outline ${
                      errors.cpin ? "border-red" : ""
                    }`}
                    id="cpin"
                    type="password"
                    placeholder="Neue Pin Bestätigen"
                    value={formData.cpin}
                    onChange={handleChange}
                    maxLength={4}
                  />
                  {errors.cpin && (
                    <p className="text-red text-sm mt-1">{errors.cpin}</p>
                  )}
                </div>
                <button
                  className="bg-blue w-full uppercase hover:bg-blue-800 text-white font-roboto font-bold py-3 px-5 rounded-xl focus:outline-none focus:shadow-outline transition-all ease-in"
                  type="button"
                  onClick={handleSubmit}
                >
                  Setzen Sie Ihre Pin Zurück
                </button>
                <div className="text-center mt-5">
                  <Link
                    className="inline-block text-center font-bold font-inter text-2xl text-gray-700 transition-all ease-in hover:text-dark-gray"
                    to="/"
                  >
                    Zurück zum Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <ResetPopup openPopUp={openPopup} closePopUp={HandleClosePopup} />
      <VerifyTokenPopup openPopUp={openPopup2} closePopUp={HandleClosePopup2} />
    </>
  );
};

export default Reset;
